const PasswordRequirements = {
  parts: [
    'container',
    'item',
    'icon',
    'text'
  ],
  baseStyle: {
    container: {
      gap: 2,
    },
    item: {
      gap: 2,
      alignItems: 'flex-start',
    },
    icon: {
      width: 4,
      height: 4,
      color: 'brandColors.green',
    },
    text: {
      color: 'brandColors.greyscale60',
      fontFamily: 'heading',
      fontSize: 'xs',
      fontStyle: 'normal',
      fontWeight: 'normal',
      lineHeight: '140%',
    },
  },
};

export default PasswordRequirements;
